import { Routes } from '@angular/router';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { RecurrencesComponent } from './recurrences.component';
var ɵ0 = { title: 'CORE.SERVICES.NAVIGATION.RECURRENCES' };
var routes = [
    {
        path: 'recorrencias',
        component: RecurrencesComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ0
    }
];
var RecurrencesModule = /** @class */ (function () {
    function RecurrencesModule() {
    }
    return RecurrencesModule;
}());
export { RecurrencesModule };
export { ɵ0 };
